import { FC } from "react";
import { Text, View } from "react-native";
import CheckMainBlock from "@/app/components/CheckMainBlock";
import InputWithBlur from "@/app/components/InputWithBlur";
import CheckBalance from "@/app/components/CheckBalance";
import CustomButton from "@/app/components/CustomButton";

interface CheckBlockProps {
  index?: number;
  title: string;
  description: string;
  bgColor: string;
  bgImage: any;
  buttonColor: string;
  checkBalance: string;
  hasInput?: boolean;
  openSheet: (index?: number) => void;
}

const CheckBlock: FC<CheckBlockProps> = ({
  index,
  title,
  description,
  bgColor,
  bgImage,
  buttonColor,
  checkBalance,
  hasInput = false,
  openSheet,
}) => {

  return (
    <CheckMainBlock bgColor={bgColor} bgImage={bgImage}>
    <Text className="text-white text-2xl font-bold mb-3">
      {title}
    </Text>
    <Text className="text-white text-base font-normal opacity-80 mb-5">
      {description}
    </Text>
    {hasInput && <InputWithBlur placeholder="Введите ИНН" placeholderTextColor="rgba(255, 255, 255, 0.80)"/>}
    <CustomButton
      className="mb-4"
      title="Проверить сейчас"
      type="primary"
      style={{ backgroundColor: "white" }}
      textStyle={{ color: buttonColor }}
      onPress={() => openSheet(index)}
    />
    <View className="flex-row items-center justify-center space-x-2">
      <Text className="text-white text-sm font-normal">
        Осталось:
      </Text>
      <CheckBalance>
        {checkBalance}
      </CheckBalance>
    </View>
  </CheckMainBlock>
)};

export default CheckBlock;
